<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <form class="form" [formGroup]="model"  (ngSubmit)="submit()">
        <div class="row">
            <div class="col-12">
                <h1 class="title-default">Categoria Arquivo</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Nome</mat-label>
                    <input matInput formControlName="nome" type="text">
                    @if (model.get('nome')?.invalid) {
                        <mat-error>Informe um nome</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>     
        <div class="row">
            <mat-form-field class="lista-tag-arquivo">
                <mat-label>Tags</mat-label>
                <mat-chip-grid
                    #chipGrid
                    [formControl]="formControlTagArquivo"
                    >
                    @for (tagArquivo of _listaTagArquivoPorCategoria; track tagArquivo) {
                        <mat-chip-row (removed)="removeTagArquivo(tagArquivo.idTagArquivo)">
                            {{tagArquivo.nome}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip-row>
                    }
                </mat-chip-grid>
                <input
                placeholder="Nova tag..."
                [matChipInputFor]="chipGrid"
                (matChipInputTokenEnd)="addTagArquivo($event)"
                />
                @if (formControlTagArquivo.invalid) {
                    <mat-error>Informe pelo menos uma tag</mat-error>
                }
            </mat-form-field>
        </div>   
        <div class="row">
            <div class="custom-container">
                <mat-form-field appearance="outline" class="custom-textarea">
                  <mat-label>Observação</mat-label>
                  <textarea formControlName="observacao" matInput placeholder="Observação..." rows="5"></textarea>
                  @if (model.get('observacao')?.invalid) {
                    <mat-error>Informe uma observação</mat-error>
                }
                </mat-form-field>
                <mat-icon class="info-icon" matTooltip="Na observação, informe quais serão os completo relacionados a essa categoria. 
                    Se necessário, utilize as outras categorias já cadastradas como exemplo.">info_outline</mat-icon>
            </div>
        </div>   
        <div class="row">
            <div class="col-md-2">
                <button type="submit" mat-flat-button class="btn-primary button-big">
                    @if (_isLoading === true) {
                        <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                    }
                    @else{
                        Salvar
                    }
                </button>
            </div>
        </div>
    </form>
</div>